import { HStack, Text } from '@chakra-ui/react'
import { themeColors } from 'theme'

import { CheckmarkIcon, StarIcon } from 'components/SVGS'

import { planInformation, PlanInformationType } from './planInformation'

interface PlanItemProps {
  isPremium?: boolean
}

const PlanItems: React.FC<PlanItemProps> = ({ isPremium = false }) => {
  let plans: PlanInformationType[]
  const { text: { smallText } } = themeColors

  isPremium ? plans = planInformation : plans = planInformation.filter(x => x.isPremium === false)

  return (
    <>
      {
        plans.map(x =>
          <HStack key={x.key} spacing={2}>
            {x.iconType === 'success' ? <CheckmarkIcon size={7} /> : <StarIcon size={7} />}
            <Text color={smallText} variant='MD'>{x.name}</Text>
          </HStack>
        )
      }
    </>
  )
}

export default PlanItems
